module.exports = __webpack_public_path__ + "img/hygh.d6ab9910.png";